import moment from 'moment';

export const manualCashLimitValueValidator = (t, minLimitValue, maxLimitValue) => (input) => {
    let err = null;
    const parsedInput = parseFloat(input);
    if (!input) {
        err = t('manual-cash-limits.validation.manual-cash-limit-value-empty');
    } else if (!input.match(/^-?\d+(\.\d{0,2})?$/)) {
        err = t('manual-cash-limits.validation.manual-cash-limit-value-invalid-number');
    } else if (parsedInput < minLimitValue) {
        err = t('manual-cash-limits.validation.manual-cash-limit-value-lower-than-min', { minLimitValue });
    } else if (parsedInput > maxLimitValue) {
        err = t('manual-cash-limits.validation.manual-cash-limit-value-greater-than-max', { maxLimitValue });
    }
    return err;
};

export const manualCashLimitStartDateValidator = (t, invalidBeforeDate) => (input) => {
    let err = null;
    if (!input) {
        err = t('manual-cash-limits.validation.manual-cash-limit-start-date-empty');
    } else if (!(input instanceof Date)) {
        err = t('manual-cash-limits.validation.manual-cash-limit-start-date-not-a-date');
    } else if (input < invalidBeforeDate) {
        err = t('manual-cash-limits.validation.manual-cash-limit-start-date-not-before', { invalidBeforeDateFormatted: moment(invalidBeforeDate).format('DD.MM.YYYY') });
    }
    return err;
};

export const manualCashLimitEndDateValidator = (t, beginDate, invalidBeforeDate) => (input) => {
    let err = null;
    if (input && !(input instanceof Date)) {
        err = t('manual-cash-limits.validation.manual-cash-limit-end-date-not-a-date');
    } else if (input && (input < invalidBeforeDate)) {
        err = t('manual-cash-limits.validation.manual-cash-limit-end-date-not-before', { invalidBeforeDateFormatted: moment(invalidBeforeDate).format('DD.MM.YYYY') });
    } else if (input && beginDate && input < beginDate) {
        err = t('manual-cash-limits.validation.manual-cash-limit-end-date-not-before-begin-date');
    }
    return err;
};

export const MANUAL_CASH_LIMIT_DESCRIPTION_MAX_LENGTH = 255;
export const manualCashLimitDescriptionValidator = (t) => (input) => {
    let err = null;
    if (input.length > MANUAL_CASH_LIMIT_DESCRIPTION_MAX_LENGTH) {
        err = t('manual-cash-limits.validation.manual-cash-limit-description-too-long', { maxLetters: MANUAL_CASH_LIMIT_DESCRIPTION_MAX_LENGTH });
    }
    return err;
};
